import { fetchTemplateInstances } from 'common/services/template'
import { Template } from 'common/types/entities/mongo/template'
import { ArrayUtils } from '@shopping/common'
import { isPcEnv } from 'common/utils/common'

const templateID = 'HOME_MEAL_VIDEO_BANNER'

export interface MovingBannerState {
  banners: MovingBannerData[]
}

export interface MovingBannerData {
  title: string
  subTitle: string
  mobileImage: string
  pcImage: string
  mobileLandingUrl: string
  pcLandingUrl: string
}

const initialState: MovingBannerState = {
  banners: [],
}

// action types
const INIT = 'homemeal/movingBanner/INIT'

// action creators
export const initMovingBanner = () => async (dispatch, getState) => {
  if (ArrayUtils.isNotEmpty(getState().movingBanner.banners)) return
  const templates: Template[] = await fetchTemplateInstances(templateID, {})
  const bannerSize = isPcEnv ? ArrayUtils.size(templates) : 1
  const shuffledBanner: MovingBannerData[] = ArrayUtils.shuffle(templates)
    .slice(0, bannerSize)
    .map(convertToBanner)
  dispatch({ type: INIT, banners: shuffledBanner })
}

const convertToBanner = (template: Template): MovingBannerData => {
  const rawBanner = { ...template.data }
  delete rawBanner._id
  return Object.keys(rawBanner).reduce((banner, key) => {
    return Object.assign(banner, { [key]: rawBanner[key].value })
  }, {}) as MovingBannerData
}

// reducer
export default (state: MovingBannerState = initialState, action) => {
  if (action.type === INIT) {
    return { banners: action.banners }
  }
  return state
}
